import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Store(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Store", sx, viewBox, children: [
    /* @__PURE__ */ jsx("path", { d: "M38 44H10c-1.1 0-2-.9-2-2V18h32v24c0 1.1-.9 2-2 2Z", fill: theme.vars.palette.primary.light }),
    /* @__PURE__ */ jsx("path", { d: "M8 28c-2.2 0-4-1.8-4-4v-6h8v6c0 2.2-1.8 4-4 4Z", fill: theme.vars.palette.primary.dark }),
    /* @__PURE__ */ jsx("path", { d: "M16 28c-2.2 0-4-1.8-4-4v-6h8v6c0 2.2-1.8 4-4 4Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx("path", { d: "M24 28c-2.2 0-4-1.8-4-4v-6h8v6c0 2.2-1.8 4-4 4Z", fill: theme.vars.palette.primary.dark }),
    /* @__PURE__ */ jsx("path", { d: "M32 28c-2.2 0-4-1.8-4-4v-6h8v6c0 2.2-1.8 4-4 4Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx("path", { d: "M40 28c-2.2 0-4-1.8-4-4v-6h8v6c0 2.2-1.8 4-4 4Z", fill: theme.vars.palette.primary.dark }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M44 18H4L8.5 6.3c.3-.8 1-1.3 1.9-1.3h27.3c.8 0 1.6.5 1.9 1.3L44 18Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M28 32h-8v12h8V32Z", fill: theme.vars.palette.primary.dark })
  ] });
}
Store.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Store"
};
validateTidalLicense();
export {
  Store
};
//# sourceMappingURL=Store.js.map
